<template>
  <div class="basket" :class="{ invert }">
    <a href="/panier">Panier <span class="hide_if_no_order">({{ nb_total }})</span></a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      invert: false,
    };
  },
  mounted() {
    window.subscribe("ADD_TO_BASKET", () => {
      this.invert = 1;
      window.setTimeout(() => {
        this.invert = 0;
      }, 500);
    });
  },
  computed: {
    nb_total() {
      return this.$store.state.items.reduce((b, a) => {
        if (a.type === "book") {
          return b + a.qty;
        } else {
          return b + 1;
        }
      }, 0);
    }
  }
};
</script>

<style lang="scss">
  .cannot_order {
    .hide_if_no_order {
      display:  none;
    }
  }
  .hide_if_no_order {
    margin-left: 0!important;
  }
</style>